class AppService {
    public commentWarningMsgHtml = `<p>
        Ne renseignez dans ce champ que des mentions neutres et objectives
        permettant d’expliquer les paramétrages particuliers de
        l’application.
    </p>
    <p>
        Par exemple : « Protection automatique activée en journée seulement
        », ou « fonctionnalité X désactivée » …
    </p>`;
}

export const appService = new AppService();
